import React, { Component } from 'react';

import { AppState, Actions, store, IPageState } from '../appredux'

import { connect } from 'react-redux';

import { withStyles, WithStyles, createTheme, ThemeProvider } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import platnosciLogo from 'app/assets/Przelewy24_logo.png'

import { Paper, Box, CardMedia } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { MuiThemeProvider } from '@material-ui/core/styles';

import themeDialog from '../themes-dialog';


import DialogDelete from './dialog/Delete';
import DialogError from './dialog/Error';
import DialogOrder from './formularz/Order';
import { zbudujLiczbeLosowa, sendErrorLog } from './common/helpers';
import { fontSelect } from '../fonts';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PhotoOutlinedIcon from '@mui/icons-material/PhotoOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { AsortMenuWiersz, AsortWWWMenuNagl, Font, WWWSprzedazInfo } from '../api';
import CONFIG from '../cfg/config';
import roomImg from 'app/assets/noImage.jpg';
import ResponsiveImgMaterialUi from 'responsive-img-material-ui';


interface PanelRightProps {
  page: IPageState
}

interface PanelRightState {
  
}

class PanelRight extends Component<PanelRightProps & WithStyles<typeof styles>, PanelRightState> {
  textTheme = fontSelect(this.props.page.fonts, 5, 1) as React.CSSProperties;
  contentTheme = fontSelect(this.props.page.fonts, 6, 2) as React.CSSProperties;

  logoUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/logo.png`

  constructor(props: PanelRightProps & WithStyles<typeof styles>) {
    super(props, {});

    this.state = {
     
    };
  }

 
  ImgError = (source: any) => {
    source.target.src = roomImg;
    source.onerror = "";
    return true;
    }

  render() {

    const { classes } = this.props;

    let color = "#5F9EA0"
    if(this.textTheme && this.textTheme.color){
        color = this.textTheme.color
    }

    let padding = CONFIG.kelnerBookFoto !== '0' && ( CONFIG.zasady1 === "1" || CONFIG.zasady2 === "1" || CONFIG.zasady3 === "1" || CONFIG.ikonaPrzelewy24 === "1")

    return (
        <div style={{paddingTop: padding ? "15px" : "0"}}>
        {CONFIG.kelnerBookFoto === '0' ?
        <>
          {/* <CardMedia
            
            id="CardMediaLogo"
            style={{ height: "150px", width: "150px", margin: "1em auto auto" }}
            //image={this.logoUrl}
            image={require('app/assets/logo-kulinarne-pysznosci.png').default}
          
          /> */}
         
         <div style={{ width: "fit-content", margin: 'auto', alignItems: "center", display: "flex"}}>
            <ResponsiveImgMaterialUi style={{ width: "150px", padding: "1em 0px" }}
                 //xs={require('app/assets/logo-kulinarne-pysznosci.png').default}
                 //md={require('app/assets/logo-kulinarne-pysznosci.png').default}
                 //lg={require('app/assets/logo-kulinarne-pysznosci.png').default}
                 xs={this.logoUrl}
                 md={this.logoUrl}
                 lg={this.logoUrl}
            />
            </div>
            {/* <ResponsiveImgMaterialUi style={{ width: "150px", padding: "1em 20px 0px" }}
                 xs={this.logoUrl}
                 md={this.logoUrl}
                 lg={this.logoUrl}
            /> */}
          </>
          : null}



            <ThemeProvider theme={createTheme({
                palette: {
                    primary: {
                        main: `${color}`,
                    },
                },
            })}>

                {CONFIG.zasady1 === "1" ?
                    <div style={{ textAlign: 'center', padding: "4px 0px" }}>
                        <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady1Link}`} className={classes.link1} target="_blank" rel="noreferrer">
                            <Button variant="outlined" size="medium" color="primary" className={`${classes.button}`}>
                                {CONFIG.zasady1Opis}
                            </Button>
                        </a>
                    </div>
                    : null}

                {CONFIG.zasady2 === "1" ?
                    <div style={{ textAlign: 'center', padding: "4px 0px" }}>
                        <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady2Link}`} className={classes.link1} target="_blank" rel="noreferrer">
                            <Button variant="outlined" size="medium" color="primary" className={` ${classes.button}`}>
                                {CONFIG.zasady2Opis}
                            </Button>
                        </a>
                    </div>
                    : null}

                {CONFIG.zasady3 === "1" ?
                    <div style={{ textAlign: 'center', padding: "4px 0px" }}>
                        <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady3Link}`} className={classes.link1} target="_blank" rel="noreferrer">
                            <Button variant="outlined" size="medium" color="primary" className={` ${classes.button}`}>
                                {CONFIG.zasady3Opis}
                            </Button>
                        </a>
                    </div>
                    : null}

            </ThemeProvider> 

        {CONFIG.ikonaPrzelewy24 === "1" ?
          <div style={{ textAlign: 'center', marginBottom: "1px", padding: "15px 20px 10px"}}>
            <a className={classes.alignCenter} href={`https://vsc24.net/vscZasady/zasady/Przelewy24/${CONFIG.hotelID}`} target="_blank" rel="noreferrer">
              {/* require('./Przelewy24_logo.png').default */}
              <img src={platnosciLogo} className={`${classes.imgP24} `} alt="Płatności Przelewy24" />
            </a>
          </div>
          : null}

        </div>
    );
  }
}

const styles = (theme: Theme) => ({
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere',
        color: theme.palette.error.main
      },
      link1: {
        textDecoration: 'none',
       },
      alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
      },
      button: {
        //padding: 0,
        borderRadius: "0",
        borderColor: "lavender",
        fontSize: '12px',
        lineHeight: '1.5',
        letterSpacing: '0.00938em',
        textTransform: 'none' as 'none',
        minWidth: 170,

        //"&:hover": {
        //    background: 'none'
        //}
    },
    imgP24:{
        maxWidth: '100px',
        cursor: "pointer",
        "@media (max-width: 599px)": {
          maxWidth: '80px', 
        }
      },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
})

export default connect(mapStateToProps)(withStyles(styles)(PanelRight))
